var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightLineWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "41px",
    viewBox: "0 0 42 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDE487EC-A609-438F-BFA4-CBACB8681C39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEATHER-CHANGES",
    transform: "translate(-96.000000, -276.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-line-BACK",
    transform: "translate(117.000000, 296.500000) scale(-1, 1) translate(-117.000000, -296.500000) translate(96.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "31.95045 17.8645734 17.86995 3.72727033 21.582225 0 42 20.5001581 21.582225 41 17.86995 37.272756 31.95045 23.1357429 0 23.1357429 0 17.8645734"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLineWhite);
export default __webpack_public_path__ + "static/media/arrow-right-line-white.fdd3c4b97f40f22251f298a61b8a7d2a.svg";
export { ForwardRef as ReactComponent };